import { render, staticRenderFns } from "./DashboardLifeskillsFavoritesView.vue?vue&type=template&id=698d5fd5&scoped=true&"
import script from "./DashboardLifeskillsFavoritesView.vue?vue&type=script&lang=js&"
export * from "./DashboardLifeskillsFavoritesView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLifeskillsFavoritesView.vue?vue&type=style&index=0&id=698d5fd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698d5fd5",
  null
  
)

/* custom blocks */
import block0 from "./DashboardLifeskillsFavoritesView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports